import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import cssTheme from '@yandex-delivery/blocks/v2/theme/cssTheme'

export const divider = css`
  inline-size: calc(100% + ${spacing(4)});
  transform: translateX(${spacing(-2)});
`

export const summarization = css`
  background-color: ${cssTheme.colors.warmGray['100']};
  border-radius: ${spacing(2)};
  margin-block-end: ${spacing(2)};
  & * {
    text-align: center;
  }
  &&&&:before {
    // оверрайд стиля гвц
    border: none;
  }
`
